import { render, staticRenderFns } from "./all_purchases.vue?vue&type=template&id=89474e66&scoped=true"
import script from "./all_purchases.vue?vue&type=script&lang=js"
export * from "./all_purchases.vue?vue&type=script&lang=js"
import style0 from "./all_purchases.vue?vue&type=style&index=0&id=89474e66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89474e66",
  null
  
)

export default component.exports